const TITLE_GEMX = 'GemX Dashboard';

export function useConvertPathnameToTitle() {
  function convertPathnameToTitle(pathname = '') {
    const segments = pathname.split('/').filter(Boolean);
    const title = segments.map(capitalizeFirstLetter).join(' ');
    return `${title ? `${title} - ${TITLE_GEMX}` : TITLE_GEMX}`;
  }

  function capitalizeFirstLetter(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  return { convertPathnameToTitle };
}
